export const getDevicesPsirt = (state) => state.adom.devicesPsirt || {};

export const getPsirtByPlatform = (state) => getDevicesPsirt(state).byPlatform;

export const getPsirtByIrNumber = (state) => getDevicesPsirt(state).byIrNumber;
